document.addEventListener("click", function (event) {
  const trigger = event.target.closest("[data-vdw-sample-trigger]");

  if (!trigger) return;

  event.preventDefault();

  const realSampleButton = document.querySelector(
    ".product-samples-button-wrap [product-samples-button]"
  );

  if (!realSampleButton) {
    console.warn("Product Samples-knop niet gevonden.");
    return;
  }

  realSampleButton.click();
});